
<div class="backgroundDialog" style="width: 100%;  height: 100%; padding: 0px;margin: auto; border: 5px solid rgb(207, 121, 1);">

  <div style="width: 100%; height: 100%; ">

    <div style="text-align: center; width: 5%;display: inline-block;  " >
      <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                        background-color: rgb(46, 163, 80); font-size: 20px;">
          &nbsp;&nbsp;Contestação
      </mat-card>
    </div>
    <div style="text-align: right; width: 93%; display: inline-block; " >
      <button  [mat-dialog-close]="true">
        <img src="../../assets/img/icones/fecharJanela.png" width="100%">
    </button>
    </div>
  
    
    

    <form [formGroup]="formContested" novalidate >
        
      <!--Definir o tamanho da tela-->
      <div style=" width: 100%; overflow:hidden; text-align: center; border-top: 5px solid rgb(207, 121, 1);
                  background-color: rgb(51, 68, 75); text-align: center;">
      
          <div style="width: 100%; ">
        
              <table style="width: 98%; margin: 10px;   ">
                
                <tr>

                  <td style="width: 100%;">
                       
                    <div style=" width: 100%; text-align: center; margin-bottom: 9px;">
                      <label style="color: white;">{{formContested.value.pergDsPergunta}}</label>
                      <label style="color: white; font-weight: 500; margin-left: 10px;">[ {{formContested.value.respDsResposta}} ]</label>
                    </div>
                    
                  </td>
                </tr>

              </table>
        </div>

        <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>   
        
      </div>

      <div id="divContainerListaContestacao" style="width: 100%;">

        <div id="divAdjustAutoHeightContestacao" style="overflow-y: auto; border-bottom: 5px solid rgb(207, 121, 1);">

            <table style="width: 100%;  margin: auto; padding: 0px;  " >
                
                <tr>
                    
                    <td style="width:100%; padding: 0px;  ">
              
                      <div style="background-color: lightgrey; padding: 0px; color: rgb(138, 138, 140); overflow: hidden;">
                        




















                        <div *ngIf="data.mqa.contestations.length == 0" style="width: 100%; background-color: rgb(180, 180, 180) " >
                          <!--Botão para Adicionar Resposta-->
                          
                          <table style="text-align: left; width: 98%; height: 98%; margin: auto; margin-top: -10px; ">
                            <tr >
                              <td style="width: 100%; height: 100%;" >
                                <div  style="font-size: 12px; height: 100%;">                                
                                    <table style="width: 100%; text-align: center;" >
                                      <tr>
                                        <td style="width: 10%; text-align: center; height: 70px;">
                                          <button mat-raised-button  type="button" (click)="showNewContestacao()" 
                                            style="background-color: rgb(46, 163, 80); color: #fff; width: 100%; margin-top: 5px; font-size: 16px; cursor: pointer;">
                                            <label *ngIf="!isAddContestacao && tipoUsuarioLogado == 2 && moniDhFeedbackAvaliado == null" style="margin-top: 5px; cursor: pointer;"> + Adicionar Contestação</label>
                                            <!--<label *ngIf="isAddContestacao" style="margin-top: 5px; cursor: pointer;"> - Adicionar Contestação</label>-->
                                          </button>
                                        </td>
                                        <td style="width:90%; text-align: center;">
                                        &nbsp;
                                        </td>
                                      </tr>
                                    </table>
                                </div>
                              </td>                              
                            </tr>
                          </table>
                          <label *ngIf="tipoUsuarioLogado != 2 " style="margin-left: 15px; color: white; width: 100%; text-align: center;" > 
                            É permitido a inclusão de contestações apenas pelo Usuário Supervisor<br/>
                          </label>
                          <label *ngIf="moniDhFeedbackAvaliado != null " style="margin-left: 15px; color: white; width: 100%; text-align: center;" > 
                            Monitoria encerrada <br/>
                          </label>

                          <div *ngIf="isAddContestacao" >
                            <table style="text-align: left; width: 98%; height: 98%;  margin: auto; ">
                              <tr >
                                <td style="width: 100%; height: 100%;" >
                                  <div  style="font-size: 12px; height: 100%;">                                
                                    <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 2px;  margin-bottom: 15px;
                                                    background-color:rgb(207, 121, 1);" class="mat-elevation-z4"> 
                                      <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); background-color:rgb(252, 247, 242); padding: 5px; " class="mat-elevation-z4"> 
                                        
                                        <table style="width: 100%; text-align: left; " >
                                          <tr>
                                            <td style="width: 100%;  ">
                                              
                                                <mat-form-field  appearance="outline">
                                                  <mat-label>
                                                    <img src="../../assets/img/icones/setaDuplaDireita.png" width="16px">&nbsp;
                                                    Descrição da contestação
                                                  </mat-label>
                                                  <textarea rows="2" formControlName="contTxContextacao" style="resize: none; white-space: pre-line;" matInput placeholder="Descrever resposta" ></textarea>
                                                </mat-form-field>
                                                
                                                <table style="width: 100%; text-align: left; margin-top: -10px;" >
                                                  <tr>
                                                    <td style="width: 50%; ">
                                                     
                                                    <input type="file" class="file-input" id="anexoMonitoria"
                                                        [accept]="requiredFileType"
                                                        (change)="onFileSelectedContestacao($event, fileUpload)" #fileUpload style="display: none;">

                                                    <div class="file-upload" style="vertical-align: bottom;">
                                                      
                                                      <button *ngIf="!contemAnexo" mat-mini-fab style="background-color: rgb(207, 121, 1); width: 40px; height: 40px; " class="upload-btn"
                                                        (click)="fileUpload.click()">
                                                          <mat-icon style="width: 25px;"> attach_file</mat-icon>
                                                      </button>

                                                      <button *ngIf="contemAnexo" mat-mini-fab style="background-color: rgb(207, 121, 1);" class="upload-btn"
                                                        (click)="downloadAnexoContestacao()">
                                                          <mat-icon>cloud_download</mat-icon>
                                                      </button>

                                                      &nbsp;
                                                      {{fileName || "Sem arquivo."}}


                                                          <mat-icon  *ngIf="contemAnexo" style="color: rgb(248, 41, 110);  vertical-align: middle; cursor: pointer; font-weight: bold;"
                                                              (click)="deletarAnexo()">
                                                              close
                                                          </mat-icon>

                                                    </div>










                                                    </td>
                                                    <td style="width: 25%; ">
                                                      <button mat-raised-button  type="button" (click)="salvarContestacao(data.mqa.permNrSequencia)"
                                                        style="background-color: rgb(46, 163, 80); color: #fff; width: 100%; 
                                                        font-size: 12px;">
                                                        + Contestar
                                                      </button>
                                                    </td>
                                                    <td style="width: 25%; ">
                                                      <button mat-raised-button  type="button" (click)="cancelNewContestacao()"
                                                        style="background-color: red; color: #fff; width: 100%; 
                                                        font-size: 12px;">
                                                        cancelar
                                                      </button>
                                                      
                                                    </td>
                                            
                                              </tr>
                                            </table>
                                          </td>
                                          </tr>
                                        </table>
                                      </mat-card>
                                    </mat-card>
                                  </div>
                                </td>                              
                              </tr>
                            </table>
                          </div>

                        </div>






















                        
                        

                        
                  <!--  CONTESTAÇÕES -->
                        <div *ngFor="let lstContestation of data.mqa.contestations; let i = index" [attr.data-index]="i" style="width: 100%; margin-top: 25px; text-align: center;">
                            <table  style="text-align: left; width: 95%; height: 98%; margin-top: 20px; margin: auto;">
                              <tr >
                                <td style="width: 100%; height: 100%;" >
                                <div style="width:100%; font-size: 12px;">
                                  <table style="width: 100%; text-align: center;">
                                    <tr>
                                      <td style="width: 78%; text-align: center;">
                                        <div style="width: 100%; background-color: rgb(46, 163, 80);  height: 30px; color: white; margin-bottom: -2px;
                                          border-radius: 10px  30px 0px 0px; float:left; font-size: 16px;">
                                          Contestação Supervisão Operacional
                                        </div>
                                      </td>
                                      <td style="width: 22%;">
                                        <div  style="width: 100.5%; background-color: rgb(32, 114, 55);  color: white; margin-bottom: -12px; margin-left: -18px;
                                              border-radius: 0px  30px 0px 0px; ">
                                          {{lstContestation.contDhRegistro | date: 'dd/MM/yyyy HH:mm'}} 
                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                                <div  style="font-size: 12px; height: 100%;">                                
                                  <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 2px;  margin-bottom: 15px;
                                                  background-color:rgb(207, 121, 1);" class="mat-elevation-z4"> 
                                    <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); background-color:rgb(252, 247, 242); padding: 5px; " class="mat-elevation-z4"> 

                                      <table style="width: 100%; text-align: left; margin-bottom: - 25px; " >
                                        <tr>
                                          <td style="width: 79%; ">

                                            <div style="width: 100%; background-color: rgb(51, 68, 75); height: 20px; color: white; margin: auto;
                                              border-radius: 0px  0px 30px 0px; float:left; margin-top: -7px; margin-left: -7px; ">
                                               &nbsp;&nbsp;&nbsp;&nbsp;{{lstContestation.userContestacao.usuaNmUsuario}}
                                            </div>

                                            
                                            <label style="font-size: 14px; font-weight: 500; margin-top: 10px; margin-left: 20px;">
                                              &nbsp;&nbsp;<img src="../../assets/img/icones/setaDuplaDireita.png" width="16px">&nbsp;
                                              {{lstContestation.contTxContestacao}}
                                            </label>
                                            

                                          </td>
                                          <td style="width: 21%; text-align: center;  cursor: pointer;" (click)="downloadAnexosDaContestacao(lstContestation.contDsArquivo, lstContestation.contDsNomeArquivo)" >
                                            <img src="../../assets/img/icones/anexoAzul.png" width="20px" *ngIf="lstContestation.contDsNomeArquivo != null"> 
                                            {{lstContestation.contDsNomeArquivo}}
                                          </td>
                                        </tr>
                                      </table>
                                      <hr style="margin-top: -05px;"/>
                                     
                                      <div  style="width:100%; text-align: center; margin-top: -17px;">
                                        <div  *ngIf="statusDaContestacaoSuperior != ''" style=" margin: 0 auto; width: 99%; background-color: rgb(51, 68, 75); color:white; font-weight: 500; border-bottom-left-radius: 30px; border-bottom-right-radius: 30px">
                                         {{statusDaContestacaoSuperior}} 
                                        </div>
                                      
                                      </div>
                                      <br/><br/>  


                                   
                                 



                                  <!-- RESPOSTAS -->
                                      <div *ngFor="let lstAnswers of lstContestation.contestationAnswers" >
                                        <table style="text-align: left; width: 90%; height: 98%; margin-top: 10px; margin: auto; ">
                                          <tr >
                                            <td style="width: 100%; height: 100%;" >
                                              <div style="width:100%; font-size: 12px;">
                                                <table style="width: 100%; text-align: center;">
                                                  <tr>
                                                    <td style="width: 70%; text-align: center;">
                                                      <div  [ngClass]="lstAnswers.userRespostaContestacao.tiusIdCdTipoUsuario == 2 ? 'abaTituloRespostaContestacaoSupervisor' : 'abaTituloRespostaContestacaoMonitor'">
                                                        Resposta 
                                                        <label *ngIf="lstAnswers.userRespostaContestacao.tiusIdCdTipoUsuario == 2"> Supervisão</label>
                                                        <label *ngIf="lstAnswers.userRespostaContestacao.tiusIdCdTipoUsuario == 4"> Avaliação</label>                                                        
                                                      </div>
                                                    </td>
                                                    <td style="width: 30%;">
                                                      <div  [ngClass]="lstAnswers.userRespostaContestacao.tiusIdCdTipoUsuario == 2 ? 'abaDhRespostaContestacaoSupervisor' : 'abaDhRespostaContestacaoMonitor'">
                                                        {{lstAnswers.recoDhRegistro | date: 'dd/MM/yyyy HH:mm'}}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                </table>
                                              </div>
                                              
                                              <div  style="font-size: 12px; height: 100%;">                                
                                                <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 2px;  margin-bottom: 15px;
                                                                background-color:rgb(207, 121, 1);" class="mat-elevation-z4"> 
                                                  <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); background-color:rgb(252, 247, 242); padding: 5px; " class="mat-elevation-z4"> 
                                                    <table style="width: 100%; text-align: left;" >
                                                      <tr>
                                                        <td style="width: 72%; ">
                                                          
                                                          <div style="width: 100%; background-color: rgb(51, 68, 75); height: 20px; color: white; margin-left: -25px; margin-top: -2px;
                                                             border-radius: 30px  30px 30px 30px; float:left">
                                                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{{lstAnswers.userRespostaContestacao.usuaNmUsuario}}
                                                          </div>


                                                          <br/><br/>                                                          
                                                          &nbsp;&nbsp;<img src="../../assets/img/icones/setaDuplaDireita.png" width="16px">&nbsp;
                                                          {{lstAnswers.recoTxRespostaContestacao}}
                                                          <br/><br/>


                                                        </td>
                                                        
                                                        <td style="width: 23%; text-align: center; cursor: pointer;" (click)="downloadAnexosDaContestacao(lstAnswers.recoDsArquivo, lstAnswers.recoDsNomeArquivo)">

                                                         
                                                          <img src="../../assets/img/icones/anexoAzul.png" width="20px" *ngIf="lstAnswers.recoDsNomeArquivo != null"> 
                                                            {{lstAnswers.recoDsNomeArquivo}}
                                                        </td>

                                                        <td style="width: 5%; text-align: center; cursor: pointer;">
                                                            
                                                          
                                                          <label matTooltip="Procedente"  matTooltipPosition="before"
                                                              *ngIf="lstAnswers.recoInProcedente == 'S'" style=" background-color: rgb(46, 163, 80); color:white; width: 100%; font-weight: bold; font-size: 18px; margin-top: 7px; margin-left: 0px; border: 2px solid grey; cursor: pointer; border-radius: 15px 15px 15px 15px ; ">
                                                              &#10003;
                                                          </label>
                                                          <label matTooltip="Improcedente" matTooltipPosition="before"
                                                              *ngIf="lstAnswers.recoInProcedente == 'N'" style="background-color:  rgb(248, 41, 110);  color: white; width: 100%; font-weight: bold; font-size: 18px; margin-top: 7px; margin-left: 0px; border: 2px solid grey; cursor: pointer; border-radius: 15px 15px 15px 15px ;">
                                                            X
                                                          </label>
                                                         

                                                        </td>
                                                      </tr>
                                                    </table>
                                                  </mat-card>
                                                </mat-card>
                                              </div>
                                            </td>                              
                                          </tr>
                                        </table>
                                      </div>

                                      





                                     
                                      
                                      <!--Botão para Adicionar Resposta-->
                                      <table style="text-align: left; width: 90%; height: 98%; margin-top: 10px; margin: auto; ">
                                        <tr >
                                          <td style="width: 100%; height: 100%;" >


                                            <div  style="font-size: 12px; height: 100%;">                                
                                                  <table style="width: 100%; text-align: center;" >
                                                    <tr> 
                                                      <td *ngIf="(tipoUsuarioLogado == 2 || tipoUsuarioLogado == 4) && ( (lstContestation.contestationAnswers.length == 0  && tipoUsuarioLogado == 4) || (lstContestation.contestationAnswers.length > 0 && idUsuarioLogado != lstContestation.contestationAnswers[lstContestation.contestationAnswers.length-1].usuaIdCdUsuario ))"
                                                          style="width: 10%; text-align: center;">


                                                        
                                                        <button mat-raised-button  type="button" (click)="showNewResposta(lstContestation.contIdCdContestacao, i,    lstContestation.contestationAnswers.length == 0 ? lstContestation.contTxContestacao : lstContestation.contestationAnswers[lstContestation.contestationAnswers.length-1].recoTxRespostaContestacao)" 
                                                        [ngClass]="tipoUsuarioLogado == 2 ? 'botaoRespostaContestacaoSupervisor' : 'botaoRespostaContestacaoMonitor'">
                                                          <label style="margin-top: 5px; cursor: pointer;"> + Adicionar Resposta</label>
                                                        </button>




                                                      </td>
                                                      <td style="width:90%; text-align: center;">
                                                       &nbsp;
                                                      </td>
                                                    </tr>
                                                  </table>
                                                  <br/>
                                            </div>
                                          </td>                              
                                        </tr>
                                      </table>


                                     


                                    </mat-card>
                                  </mat-card>
                                </div>
                              </td>                              
                            </tr>
                          </table>

                        </div>


                      </div>

                        
                    </td>
                </tr>
            </table>
            
        </div>
      </div>
    </form>
  </div>

</div>